export const IS_VALID_PARTS = true;
export const QO_PARTNUMBER_NOT_FOUND = 'QO_PARTNUMBER_NOT_FOUND';
export const QO_ERROR_UPC_5018 = 'QO_ERROR_UPC_5018';
export const KEY_ICON_SIZE_LARGE = 32;
export const KEY_ICON_SIZE_SMALL = 16;
export const NO_SOS_OPTIONS_FOUND = 'No SOS options found';
